<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.area_code')">
        <b-input v-model="code" disabled expanded></b-input>
      </b-field>

      <form-wrapper :validator="$v.form">
        <form-group horizontal name="name" :label="$t('attributes.name')">
          <b-input
            v-model="form.name"
            name="name"
            :placeholder="$t('message.please_input') + $t('attributes.name')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="english_name"
          :label="$t('attributes.english_name')"
        >
          <b-input
            v-model="form.english_name"
            name="english_name"
            :placeholder="
              $t('message.please_input') + $t('attributes.english_name')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="menu_name"
          :label="$t('attributes.display_name')"
        >
          <b-input
            v-model="form.menu_name"
            name="menu_name"
            :placeholder="
              $t('message.please_input') + $t('attributes.display_name')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="external_url"
          :label="$t('attributes.external_url')"
        >
          <b-input
            v-model="form.external_url"
            name="external_url"
            :placeholder="
              $t('message.please_input') + $t('attributes.external_url')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group horizontal name="email" :label="$t('attributes.email')">
          <b-input
            v-model="form.email"
            name="email"
            :placeholder="$t('message.please_input') + $t('attributes.email')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="status"
          attribute="attributes.status"
          :label="$t('attributes.status')"
        >
          <b-switch v-model="form.status" name="status"></b-switch>
        </form-group>

        <form-group
          horizontal
          name="home_top_show"
          :label="$t('attributes.home_top_show')"
        >
          <b-select v-model="form.home_top_show" name="home_top_show">
            <option value="true">{{ $t('attributes.display') }}</option>
            <option value="false">{{ $t('attributes.hide') }}</option>
          </b-select>
        </form-group>

        <form-group horizontal name="sort" :label="$t('attributes.sort')">
          <b-select v-model="form.sort" name="sort">
            <option v-for="option in sortOptions" :key="option" :value="option">
              {{ option }}
            </option>
          </b-select>
        </form-group>

        <form-group
          horizontal
          name="hide_price_description"
          :label="$t('attributes.hide_price_description')"
        >
          <b-input
            v-model="form.hide_price_description"
            name="hide_price_description"
            :placeholder="
              $t('message.please_input') +
                $t('attributes.hide_price_description')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="min_price"
          :label="$t('attributes.area_min_price')"
        >
          <b-input
            v-model.number="form.min_price"
            name="min_price"
            type="number"
            min="100"
            :placeholder="
              $t('message.please_input') + $t('attributes.area_min_price')
            "
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="promote_num"
          :label="$t('attributes.is_promote')"
        >
          <b-field>
            <b-select v-model="form.is_promote" name="is_promote" expanded>
              <option value="true">{{ $t('attributes.display') }}</option>
              <option value="false">{{ $t('attributes.hide') }}</option>
            </b-select>
          </b-field>

          <b-field
            name="promote_num"
            label-position="on-border"
            :label="$t('attributes.is_promote_count')"
          >
            <b-input
              v-model.number="form.promote_num"
              name="promote_num"
              type="number"
              min="0"
              :placeholder="
                $t('message.please_input') + $t('attributes.promote_num')
              "
              expanded
            ></b-input>
          </b-field>
        </form-group>

        <form-group
          horizontal
          name="s1_counts"
          :label="$t('attributes.area_popup')"
        >
          <b-field
            label-position="on-border"
            :label="$t('attributes.want_display')"
          >
            <b-select
              v-model="form.home_left_show"
              name="home_left_show"
              expanded
            >
              <option value="true">{{ $t('attributes.display') }}</option>
              <option value="false">{{ $t('attributes.hide') }}</option>
            </b-select>
          </b-field>

          <b-field label-position="on-border" :label="$t('attributes.seconds')">
            <b-input
              v-model.number="form.s1_counts"
              name="s1_counts"
              type="number"
              min="1"
              :placeholder="
                $t('message.please_input') + $t('attributes.seconds')
              "
              expanded
            ></b-input>
          </b-field>
        </form-group>

        <form-group horizontal>
          <b-field label-position="on-border" :label="$t('attributes.url')">
            <b-input
              v-model="form.general_url"
              name="general_url"
              :placeholder="$t('message.please_input') + $t('attributes.url')"
              expanded
            ></b-input>
          </b-field>
        </form-group>

        <form-group
          horizontal
          name="upload_size"
          :label="$t('attributes.picture_upload_size')"
        >
          <b-input
            v-model.number="form.upload_size"
            name="upload_size"
            type="number"
            min="1"
            :placeholder="
              $t('message.please_input') + $t('attributes.picture_upload_size')
            "
            expanded
          ></b-input>
        </form-group>

        <b-field horizontal>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 100%"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>
  </section>
</template>

<script>
import { required, maxLength, minValue } from 'vuelidate/lib/validators'
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'AreaBasicForm',

  props: {
    area: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      code: this.area.code,
      form: this.extractFormValues(this.area),

      sortOptions: [...Array(50).keys()].map(i => i + 1)
    }
  },
  validations: {
    form: {
      status: { required },
      sort: { required },
      name: { required, maxLength: maxLength(50) },
      english_name: { required, maxLength: maxLength(150) },
      menu_name: { required, maxLength: maxLength(150) },
      external_url: {},
      email: { required, maxLength: maxLength(500) },
      hide_price_description: { required, maxLength: maxLength(150) },
      min_price: { required, minValue: minValue(100) },
      is_promote: { required },
      promote_num: { required, minValue: minValue(0) },
      home_left_show: { required },
      s1_counts: { required, minValue: minValue(1) },
      general_url: {},
      upload_size: { required, minValue: minValue(1) }
    }
  },
  watch: {
    area(newArea) {
      this.code = newArea.code
      this.form = this.extractFormValues(newArea)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        status: data.status,
        sort: data.sort,
        name: data.name,
        english_name: data.english_name,
        menu_name: data.menu_name,
        external_url: data.external_url,
        email: data.email,
        home_top_show: data.home_top_show,
        hide_price_description: data.hide_price_description,
        min_price: data.min_price,
        is_promote: data.is_promote,
        promote_num: data.promote_num,
        home_left_show: data.home_left_show,
        s1_counts: data.s1_counts,
        general_url: data.general_url,
        upload_size: data.upload_size
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      if (!this.form.status) {
        this.$buefy.dialog.alert(
          '' +
            '因為您把線別「' +
            this.form.name +
            '」設為下架，系統將會把底下所有類別同時設定回下架。' +
            ''
        )
      }

      const api = `${AREA_API}/${this.code}/basic`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
